<template>
  <div class="talent-diagnosis">
    <h1 class="title-diagnosis">¿Cómo funciona?</h1>
    <div class="row container-diagnosis">
      <div class="col-4">
        <h2 class="subtitle"><font-awesome-icon :icon="['fab', 'whatsapp']" size="2xl" class="social-icon-mid"/></h2>
        <p class="description-diagnosis">
          1. Inicia una conversación por WhatsApp desde tu celular: 
          puedes resolver tus dudas o comenzar un diagnóstico 
          gratuito para ti o tu hijo, al instante. Sin citas, 
          sin registros, sin descargar nada.
        </p>
      </div>
      <div class="col-4">
        <h2 class="subtitle"><font-awesome-icon :icon="['fas', 'user']" size="2xl" class="social-icon-mid"/></h2>
        <p class="description-diagnosis">
          2. La familia recibirá un perfil claro, 
          gratuito y sin compromiso sobre cómo acompañar 
          a tu hijo (a) en este proceso, y el de tu hijo 
          (a) le ayudará a conocerse mejor para elegir 
          con más seguridad y sentido.
        </p>
      </div>
      <div class="col-4">
        <h2 class="subtitle"><font-awesome-icon :icon="['fas', 'screwdriver-wrench']" size="2xl" class="social-icon-mid"/></h2>
        <p class="description-diagnosis">
          3. Al adquirir un paquete Talentinus, 
          recibirás un diagnóstico profundo y 
          personalizado que te ayudará a entender 
          mejor a tu hijo, conversar con él sin presión 
          y acompañarlo con claridad en la elección de su futuro.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TalentDiagnosisSection',
  methods: {
    handleDiagnosisStart() {
      // Handle diagnosis start action
      console.log('Starting diagnosis...')
    }
  }
}
</script>

<style scoped>
.talent-diagnosis {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 651px;
  padding: 80px 48px;
  background-color: #0f2030;
  box-sizing: border-box;
}

.title {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 140%;
  text-align: center;
  color: #FFFFFF;
  margin: 0 0 54px 0;
}

.cta-button {
  width: 152px;
  height: 48px;
  background-color: #c58911;
  border: none;
  border-radius: 25px;
  color: #F5F5F5;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 10px;
  line-height: 137%;
  letter-spacing: -0.3px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: #d69a22;
}

.cta-button:active {
  background-color: #b47d0f;
}

@media (max-width: 392px) {
  .talent-diagnosis {
    padding: 40px 24px;
  }

  .title {
    font-size: 32px;
  }

  .description {
    font-size: 10px;
  }

  .cta-button {
    width: 140px;
    font-size: 9px;
  }
}

@media (max-width: 768px) {
  .talent-diagnosis {
    padding: 24px 4vw !important;
    height: auto !important;
    min-height: 420px;
  }

  .title-diagnosis,
  .title {
    font-size: 22px !important;
    margin: 16px 0 !important;
    padding: 0 8px !important;
  }

  .container-diagnosis,
  .row {
    flex-direction: column !important;
    align-items: center !important;
    gap: 18px !important;
    padding: 0 !important;
  }

  .col-4 {
    width: 95vw !important;
    min-width: 0 !important;
    margin: 0 0 18px 0 !important;
    padding: 12px !important;
    text-align: center;
  }

  .subtitle {
    font-size: 18px !important;
    margin-bottom: 8px !important;
  }

  .description-diagnosis {
    font-size: 14px !important;
    padding: 0 4px !important;
  }

  .social-icon-mid {
    font-size: 2rem !important;
  }

  .cta-button {
    width: 90vw !important;
    min-width: 120px !important;
    font-size: 14px !important;
    height: 44px !important;
    padding: 0 !important;
  }
}
</style>
